/* global DecompressionStream, CompressionStream */
async function decompressContent(base64String) {
    try {
        const binaryString = atob(base64String);
        const bytes = Uint8Array.from(binaryString, c => c.charCodeAt(0));

        const stream = new Blob([bytes]).stream().pipeThrough(new DecompressionStream('gzip'));

        const decompressedText = await new Response(stream).text();

        return JSON.parse(decompressedText);
    } 
    catch (err) {
        console.error("Decompression failed:", err);
        return null;
    }
}
async function compressContent(obj) {
    const json = JSON.stringify(obj);

    const stream = new Blob([json]).stream()
        .pipeThrough(new CompressionStream('gzip'));

    const compressedBuffer = await new Response(stream).arrayBuffer();

    return btoa(
        String.fromCharCode(...new Uint8Array(compressedBuffer))
    );
}

async function Generic_Call(sys_body) 
{
    const baseURL = `${process.env.REACT_APP_API_BASE_URL}/${sys_body.Endpoint}`;

    try {        
        const server_response = await fetch(baseURL, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(sys_body)
        });
        if (!server_response.ok) {
            throw new Error(`HTTP error! Status: ${server_response.status}`);
        }

        return await server_response.json();
    } 
    catch (error) {
        console.error('Fetch error:', error);
        return {};
    }
}
export function validateEmailData(param0) {
    let valid = true;
    try {
        let data = param0.split("@");
        if ((data[0].length < 1) || (data[0].length > 64)) {
            valid = false;
        }
        if (valid) {
            if ((data[1].length < 2) || (data[1].length > 252)) {
                valid = false;
            }
        }
    }
    catch (error) {
        valid = false;
    }
    return valid;
}
export async function login(param0, param1) {
    var data = {
        Email: param0,
        Password: param1
    };
    const compressed = true;
    const default_payload = {
        Endpoint: "uusri",
        Charlore: null,
        Tolkien: null,
        Compressed: compressed,
        Content: compressed === true ? await compressContent(data ?? {}) : JSON.stringify(data)
    };
    var payload = await Generic_Call(default_payload);
    return (payload);
}
export async function msLogin(param0) {
    var data = {
        Authorization: param0
    };
    const compressed = true;
    const default_payload = {
        Endpoint: "uusrsso",
        Charlore: null,
        Tolkien: null,
        Compressed: compressed,
        Content: compressed === true ? await compressContent(data ?? {}) : JSON.stringify(data)
    };    
    var payload = await Generic_Call(default_payload);
    return (payload);
}
export async function getRecoveryCode(param0) {
    var data = {
        Email: param0
    };
    const compressed = true;
    const default_payload = {
        Endpoint: "urpc",
        Charlore: null,
        Tolkien: null,
        Compressed: compressed,
        Content: compressed === true ? await compressContent(data ?? {}) : JSON.stringify(data)
    };

    var payload = await Generic_Call(default_payload);
    
    return (payload);
}
export async function getNewPass(param0) {
    var data = {
        Authorization: param0
    };
    const compressed = true;
    const default_payload = {
        Endpoint: "urp",
        Charlore: null,
        Tolkien: null,
        Compressed: compressed,
        Content: compressed === true ? await compressContent(data ?? {}) : JSON.stringify(data)
    };    
    var payload = await Generic_Call(default_payload);
    return (payload);
}